<template>
  <div class="container">
    <div class="flexCenter">
      <div class="topTitle">{{detail.title}}</div>
      <div class="UsDate">{{ detail.date }}</div>
      <div v-for="(item, index) in detail.qeury" :key="index">
        <div class="UsTitle"></div>
        <div class="UsContent" v-html="item.center"></div>
        <el-image
          v-if="item.UsImg"
          style="padding: 15px 0"
          v-bind:src="item.UsImg"></el-image>
      </div>
    </div>
    <div style="margin: 15px" class="dialog-footer">
      <el-button type="primary" @click="$router.push('/AboutUs')">返 回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  //接收父组件传递过来的参数
  props: {},
  //注册组件
  components: {},
  // 定义变量
  data() {
    return {
      detail: null,
    };
  },
  created() {
    this.detail = JSON.parse(localStorage.getItem("AboutUsDetail"))
  },
  //事件方法执行
  methods: {},
  //页面初始化方法
  mounted() {},
  //监听方法  click事件等，执行drawFeatures方法
  //监听值变化
  watch: {},
  //计算
  computed: {},
};
</script>

<style scoped>
@import "./../style/index.scss";
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin:20px 0 ;
}
.flexCenter {
  text-align: center;
  overflow-x: hidden;
  height: 100%;
  margin: 0 auto;
  width: 80%;
  margin-top:20px ;
}
.topTitle{
  line-height: 24px;
  font-size: 20px;
  color: #303133;
  font-weight:900
}
/deep/ .el-dialog__title {
  font-weight: 900;
  font-size: 20px;
}
.UsDate {
  font-size: 13px;
  color: #858585;
  margin: 15px 0px;
}
.UsContent {
  text-align: left;
  line-height: 25px;
  font-size: 14px;
  color: #606266;
  text-indent:2em
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin-right: 150px;
}
</style>


// WEBPACK FOOTER //
// src/components/AboutUsDetail.vue


// WEBPACK FOOTER //
// src/components/AboutUsDetail.vue